<template>
  <label :class="{
    'nwx-switcher': true,
    'disabled': disabled,
    'error': error,
  }"
  >
    <input type="checkbox"
           :value="value"
           :name="name"
           :id="id"
           v-model="localChecked"
           :disabled="disabled"
           @change="change()"
    >
    <span class="slider"></span>
  </label>
</template>

<script>
  export default {
    name: 'NwxSwitcher',
    props: {
      checked: Boolean,
      value: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: '',
      },
      error: Boolean,
      disabled: Boolean,
    },
    model: {
      prop: 'checked',
      event: 'checkbox:changed',
    },
    data() {
      return {
        localChecked: this.checked,
        programChangeEnabled: true,
      };
    },
    watch: {
      checked(checked) {
        if (this.programChangeEnabled) {
          this.localChecked = checked;
        }
        this.programChangeEnabled = true;
      },
    },
    methods: {
      change() {
        this.programChangeEnabled = false;
        this.$emit('checkbox:changed', this.localChecked);
        this.$emit('change');
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../assets/variables';

  .nwx-switcher {
    font-size: 17px;
    position: relative;
    display: inline-block;
    width: 61px;
    height: 28px;

    input {
      cursor: pointer;
      position: absolute;
      opacity: 0;
      height: 0;
      width: 0;

      &:focus ~ .slider {
        box-shadow: 0 0 0 1px @mainBlue;
      }

      &:checked ~ .slider {
        background-color: @mainBlue;
      }

      &:checked ~ .slider:before {
        background-color: #ffffff;
        transform: translateX(33px);
      }
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ffffff;
      transition: .4s;
      border-radius: 30px;

      &::before {
        position: absolute;
        content: "";
        height: 24px;
        width: 24px;
        border-radius: 20px;
        left: 2px;
        bottom: 2px;
        background-color: #DCDEE0;
        transition: .4s;
      }
    }
  }
</style>
